import { combineReducers } from 'redux';
import scheduledCourses from './scheduled_course.reducer';

const scheduledCourseAppReducer = combineReducers({
    scheduledCourses,
});

export default scheduledCourseAppReducer;


// WEBPACK FOOTER //
// src/main/content/scheduled_course/store/reducers/index.js